export function downloadUrl(url: string, filename: string) {
  const element = document.createElement("a");
  element.setAttribute("href", url);
  element.setAttribute("download", filename);
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}
